import { svgs } from 'constants'
import { Images } from 'constants'
import React from 'react'

const features = [
    {
        image: Images.OOP_1, svg: svgs.oop_1, text: 'Back Office Support',
        bg_gradient: "linear-gradient(90deg, #FFAB00 31.14%, #FFE07A 64.01%, #FFAB00 100%)", bg_1: '#FFE1A7', bg_2: '#FFECC8'
    },
    {
        image: Images.OOP_2, svg: svgs.oop_2, text: '100% Customizable',
        bg_gradient: "linear-gradient(90deg, #008CFF 27.67%, #8FCDFF 64.01%, #008CFF 100%)", bg_1: '#C5E5FF', bg_2: '#DBEFFF'
    },
    {
        image: Images.OOP_3, svg: svgs.oop_3, text: 'Payment Gateway Support',
        bg_gradient: "linear-gradient(90deg, #358A24 27.67%, #6CE960 64.01%, #358A24 100%)", bg_1: '#C7FFC3', bg_2: '#DFFFDD'
    },
    {
        image: Images.OOP_4, svg: svgs.oop_4, text: 'End-to-End Marketing Solutions',
        bg_gradient: 'linear-gradient(90deg, #363A4D 27.67%, #888AA0 64.01%, #595764 100%)', bg_1: '#D1D5E0', bg_2: '#E3E8F6'

    }
]

const features_2 = [
    {
        image: Images.OOP_5, svg: svgs.oop_5, text: 'Bonus Panels',
        bg_gradient: "linear-gradient(0deg, #B4131D -1.3%, #FF4B57 49.35%, #880810 100%)", bg_1: '#FFCFD2', bg_2: '#FFBFC3'
    },
    {
        image: Images.OOP_6, svg: svgs.oop_6, text: 'Full Setup Guidance',
        bg_gradient: "linear-gradient(0deg, #FF740D -1.3%, #FFB680 49.35%, #EE6500 100%)", bg_1: '#FFE1CB', bg_2: '#FCEBDF'
    },
    {
        image: Images.OOP_7, svg: svgs.oop_7, text: 'Affiliate Marketing',
        bg_gradient: "linear-gradient(0deg, #972F64 -1.3%, #F84FA4 49.35%, #671C42 100%)", bg_1: '#FFDEEF', bg_2: '#FFC6E3'
    },
]

const OptimizedServices = () => {

    return (
        <div className='oos-box w-full sm:w-[390px]'>
            <div className='customer-img-bg'></div>
            <div className='overlay'></div>
            <div className='oos-heading'>
                <marquee behavior="" direction="">
                    <div className='flex items-center'><div>{svgs.oos}</div> <span className='px-1'>{svgs.star}</span><div>{svgs.oos_2}</div> <span className='px-1'>{svgs.star}</span> </div>
                </marquee>
            </div>

            <div className="flex justify-center align-center">
                <div className="oos-grid grid grid-cols-2 gap-3 relative z-1">
                    {features.map((item, index) => (
                        <div key={index} className='oos-grid-item-outer' style={{ background: item.bg_gradient }}>
                            <div className='oos-grid-item'>
                                <div className="oos-grid-item-1" style={{ background: item.bg_1 }}>
                                    <img src={item.image} alt="" />
                                </div>
                                <div className='oos-grid-item-2 flex justify-center items-center' style={{ background: item.bg_2 }}>
                                    <div className='grid grid-cols-1 h-full'>
                                        <div className='flex justify-center items-center oos-svg'>
                                            {item.svg}
                                        </div>
                                        <div className='flex justify-center items-center oos-text'>
                                            <p className='mx-1'>{item.text}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>))}
                </div>
            </div>

            <div className="flex justify-center align-center m-2">
                <div className="oos-grid grid grid-cols-3 gap-3 relative z-1">
                    {features_2.map((item, index) => (
                        <div key={index} className='oos-grid-item-outer !w-[115px]' style={{ background: item.bg_gradient }}>
                            <div className='oos-grid-item !w-[111px]'>
                                <div className="oos-grid-item-1" style={{ background: item.bg_1 }}>
                                    <img src={item.image} alt="" />
                                </div>
                                <div className='oos-grid-item-2 flex justify-center items-center' style={{ background: item.bg_2 }}>
                                    <div className='grid grid-cols-1 h-full'>
                                        <div className='flex justify-center items-center oos-svg'>
                                            {item.svg}
                                        </div>
                                        <div className='flex justify-center items-center oos-text'>
                                            <p className='mx-1'>{item.text}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>))}
                </div>
            </div>

        </div>
    )
}

export default OptimizedServices